<template>
    <div class="h-auto">
      <form action="" class="p-6 h-auto" @submit.prevent="send">
        <div class="w-full flex justify-end text-orange-academy-300">
          <button @click.prevent="$emit('close')" >
            <close-icon />
          </button>
        </div>
        <div class="flex flex-row items-center">
          <div class="mr-4 uppercase w-16">{{ $t('messageForm.from') }} </div>
          <div class="text-grey-500 capitalize bg-beige-academy-100 shadow-inner px-3 h-7
            items-center flex rounded-md w-auto">
            {{ fromUser.name }} </div>
        </div>
        <div class="flex flex-row mt-4 items-center">
          <div class="mr-4 uppercase w-16">{{ $t('messageForm.to') }} </div>
          <div class="text-grey-500 capitalize px-3 bg-beige-academy-100 rounded-md h-7
            shadow-inner flex items-center"
            v-if="toUser.name"> {{ toUser.name }} </div>
          <input v-else
            type="text"
            class="outline-none px-3 bg-beige-academy-100 rounded-md h-7 shadow-inner w-full"
            v-model="toUserName" required>
        </div>
        <div class="flex flex-row mt-4 items-center">
          <div class="mr-4 uppercase w-16">{{ $t('messageForm.subject') }} </div>
          <div class="w-full">
            <input
            type="text"
            class="outline-none px-3 bg-beige-academy-100 rounded-md h-7 shadow-inner w-full"
            v-model="subject"
            required>
          </div>

        </div>

        <div class="flex flex-row mt-4">
          <!-- <div class="uppercase">{{ $t('messageForm.message') }} </div> -->
        </div>
        <div class="flex flex-row mt-4">
          <textarea
            name=""
            id=""
            class="w-full outline-none p-3 bg-beige-academy-100 shadow-inner rounded-md"
            rows="5"
            v-model="message"
            placeholder="Write the message!"
            required>
          </textarea>
        </div>
        <div class="flex justify-center">
          <button
          class="bg-orange-academy-300 border border-orange-academy-300 px-4 py-1 m-4 rounded
          text-white hover:bg-white hover:text-orange-academy-300">
            {{ $t('messageForm.send') }}
          </button>
        </div>
      </form>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  components: { CloseIcon },
  props: {
    fromUser: {},
    toUser: {},
    subj: String,
  },

  data() {
    return {
      toUserName: '',
      subject: '',
      message: '',
    };
  },

  mounted() {
    if (this.subj) this.subject = this.subj;
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  methods: {
    send() {
      const message = {
        from_user_id: this.fromUser.id,
        to_user_id: this.toUser.id,
        subject: this.subject,
        body: this.message,
      };
      axios.post('/api/messages', message).then(() => {
        this.createNotification('success', this.$t('messageForm.sent'));
        this.$emit('close');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .inner-shadow {
    --tw-shadow: inset 4px 3px 3px 4px rgba(0, 0, 0, 0.733);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0.74)), var(--tw-ring-shadow,
    0 0 rgba(0, 0, 0, 0.712)), var(--tw-shadow);
  }
</style>
